import { InputTag } from 'mixs/base/input_mixin';
export class Select extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e) {
    this.dispatch({value: e.target.value});
  }
}
riot.mixin("inputs.select", Select as riot.TagMixin)
